import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { PeoplePageSourceDerivedSignalSectionComponentProps } from './types';

export const PeoplePageSourceDerivedSignalGeneratedSection: FC<
  PeoplePageSourceDerivedSignalSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
